/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Teal_Home_Shell_SplashInputs */

const fr_teal_home_shell_splash = /** @type {(inputs: Teal_Home_Shell_SplashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer Photo de profil`)
};

/**

* @param {Teal_Home_Shell_SplashInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const teal_home_shell_splash = /** @type {((inputs?: Teal_Home_Shell_SplashInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Teal_Home_Shell_SplashInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_teal_home_shell_splash(inputs)
});